export const ERROR_NETWORK_DESC =
	"An error occurred while trying to fetch the content, retry again.";
export const ERROR_NETWORK_TITLE = "Network error";

export const INFO_NOT_FOUND_DESC = "The requested resource was not found.";
export const INFO_NOT_FOUND_TITLE = "Not found";

// Task templates
export const TEMPLATE_CREATED_TITLE = "Template saved";
export const TEMPLATE_UPDATED_TITLE = "Template updated";
export const TEMPLATE_SAVED_DESC =
	"The task template is available under Templates.";
export const ERROR_TEMPLATE_SAVE_TITLE = "Error saving template";
export const ERROR_TEMPLATE_SAVE_DESC =
	"The task template could not be saved. Please try again.";

// Template gallery
export const ERROR_GALLERY_MANIFEST_TITLE = "Could not load the gallery";
export const ERROR_GALLERY_MANIFEST_DESC =
	"The template gallery could not be reached. Please try again.";
export const ERROR_GALLERY_TEMPLATE_TITLE = "Could not load template";
export const ERROR_GALLERY_TEMPLATE_DESC =
	"The selected template could not be loaded or was not a valid template. Please try again.";
export const ERROR_GALLERY_UNTRUSTED_URL_TITLE = "Untrusted template source";
export const ERROR_GALLERY_UNTRUSTED_URL_DESC =
	"This template link does not point to a trusted source and was not opened.";
export const GALLERY_BULK_ADDED_DESC =
	"Find them under Templates in this workspace.";
export const ERROR_GALLERY_BULK_ADD_TITLE = "Some templates could not be added";
export const ERROR_GALLERY_BULK_ADD_DESC =
	"Please try adding them again from the gallery.";

// Task
export const TASK_CREATED_TITLE = "Task created";
export const TASK_CREATED_DESC = "The task was created successfully.";
export const ERROR_TASK_CREATION_TITLE = "Error creating task";
export const ERROR_TASK_CREATION_DESC =
	"The task could not be created. Please try again.";
export const TASK_CANCEL_TITLE = "Cancel this task";
export const TASK_CANCEL_DESC =
	"A stop signal will be sent to the agent if it's currently running.";
export const TASK_CANCELLED_INFO_COMPLETED = "Task cancelled";
export const ERROR_TASK_CANCEL_TITLE = "Error cancelling task";
export const ERROR_TASK_CANCEL_DESC =
	"The task could not be cancelled. Please try again.";
export const TASK_INPUT_SUBMITTED_INFO_COMPLETED = "Input submitted";
export const ERROR_TASK_INPUT_SUBMIT_TITLE = "Error submitting input";
export const ERROR_TASK_INPUT_SUBMIT_DESC =
	"The input could not be submitted. Please try again.";
export const TASK_DISPATCHED_INFO_COMPLETED = "Task dispatched";
export const ERROR_TASK_DISPATCH_TITLE = "Error dispatching task";
export const ERROR_TASK_DISPATCH_DESC =
	"The task could not be dispatched. Please try again.";
export const TASK_REOPENED_INFO_COMPLETED = "Task reopened";
export const ERROR_TASK_REOPEN_TITLE = "Error reopening task";
export const ERROR_TASK_REOPEN_DESC =
	"The task could not be reopened. Please try again.";

// Project
export const PROJECT_CREATED_TITLE = "Project created";
export const PROJECT_CREATED_DESC = "The project was created successfully.";
export const ERROR_PROJECT_CREATION_TITLE = "Error creating project";
export const ERROR_PROJECT_CREATION_DESC =
	"The project could not be created. Please try again.";

// Environment
export const ENVIRONMENT_CREATED_TITLE = "Environment created";
export const ENVIRONMENT_CREATED_DESC =
	"The environment was created successfully.";
export const ERROR_ENVIRONMENT_CREATION_TITLE = "Error creating environment";
export const ERROR_ENVIRONMENT_CREATION_DESC =
	"The environment could not be created. Please try again.";

// Agent
export const AGENT_CREATED_TITLE = "Agent created";
export const AGENT_CREATED_DESC = "The agent was created successfully.";
export const AGENT_CREDENTIAL_ROTATED_TITLE = "Credential rotated";
export const AGENT_CREDENTIAL_ROTATED_DESC =
	"A new client secret was generated. The old secret stopped working immediately.";
export const ERROR_AGENT_CREDENTIAL_ROTATION_TITLE =
	"Credential rotation failed";
export const ERROR_AGENT_CREDENTIAL_ROTATION_DESC =
	"The agent's credential could not be rotated. Try again.";
export const ERROR_AGENT_CREATION_TITLE = "Error creating agent";
export const ERROR_AGENT_CREATION_DESC =
	"The agent could not be created. Please try again.";
export const AGENT_ONLINE_TITLE = "Agent online";
export const AGENT_ONLINE_DESC = "The agent responded successfully.";
export const AGENT_OFFLINE_TITLE = "Agent offline";
export const SET_AGENT_RUNTIME_TITLE = "Change runtime version?";
export const SET_AGENT_RUNTIME_DESC =
	"Changing the runtime redeploys the agent. This can take several minutes and cannot be interrupted; the agent is unavailable until it completes.";
export const SET_AGENT_RUNTIME_CONFIRM_LABEL = "Change runtime";
export const SET_AGENT_RUNTIME_PENDING = "Updating agent runtime…";
export const AGENT_PING_PENDING = "Testing connection…";
export const ERROR_AGENT_PING_TITLE = "Ping failed";
export const ERROR_AGENT_PING_DESC =
	"Could not reach the agent. Please try again.";

// Report
export const REPORT_CREATED_TITLE = "Report created";
export const REPORT_CREATED_DESC = "The report was created successfully.";
export const ERROR_REPORT_CREATION_TITLE = "Error creating report";
export const ERROR_REPORT_CREATION_DESC =
	"The report could not be created. Please try again.";

// Project
export const DELETE_PROJECT_DESC =
	"This will also delete all tasks and jobs in this project. This operation cannot be undone.";

// Generic Resource
export const DELETE_RESOURCE_TITLE = "Delete the resource";
export const DELETE_RESOURCE_DESC = "This operation cannot be undone.";
export const DELETE_RESOURCE_INFO_COMPLETED = "Resource deleted.";
export const DELETE_RESOURCE_ERROR_FAILED =
	"The resource could not be deleted. Please try again.";

// Environment delete: blocked by dependents / takes its deployments along
export const ENVIRONMENT_DELETE_BLOCKED_TITLE =
	"This environment can't be deleted yet";
export const ENVIRONMENT_DELETE_BLOCKED_DESC =
	'Records marked "Blocks delete" still depend on it. Remove the agents deployed into it and retarget the jobs and task templates, then try again.';
export const ENVIRONMENT_DELETE_IMPACT_DESC =
	"This environment will be permanently deleted, along with the records below. This cannot be undone.";

// Force-delete an agent whose remote runtime can't be torn down
export const FORCE_DELETE_AGENT_TITLE = "Force delete agent?";
export const FORCE_DELETE_AGENT_DESC =
	"The agent's runtime couldn't be removed. It may have been deleted manually in your AWS account. Forcing will delete only the StratoNext record. You are responsible for deleting any leftover resource in your AWS account.";
export const FORCE_DELETE_AGENT_CONFIRM_LABEL = "Force delete";
export const UPDATE_RESOURCE_ERROR_FAILED = "Failed to update the resource";
export const UPDATE_RESOURCE_INFO_COMPLETED = "Resource updated";

// Asset
export const ASSET_UPLOAD_SUCCESS_TITLE = "Upload started";
export const ASSET_UPLOAD_SUCCESS_DESC = "Your file upload has been initiated.";
export const ASSET_UPLOAD_ERROR_TITLE = "Upload failed";
export const ASSET_UPLOAD_ERROR_DESC =
	"Could not get an upload URL. Please try again.";
export const ASSET_DOWNLOAD_ERROR_TITLE = "Download failed";
export const ASSET_DOWNLOAD_ERROR_DESC =
	"Could not download the asset. Please try again.";

// Deployment
export const DEPLOYMENT_GRAPH_DISCOVERING_DESC =
	"The deployment graph is being discovered. Please wait.";
export const DEPLOYMENT_GRAPH_DISCOVERING_ERROR_TITLE = "Discovery failed";
export const DEPLOYMENT_GRAPH_DISCOVERING_ERROR_DESC =
	"The deployment graph could not be discovered. Please try again.";

// Job
export const JOB_CREATED_TITLE = "Job created";
export const JOB_CREATED_DESC = "The job was created successfully.";

// Signals
export const SIGNALS_ADDED_TITLE = "Signals added";
export const ERROR_SIGNALS_ADD_TITLE = "Some signals could not be added";
export const SIGNAL_DELETE_TITLE = "Remove this signal";
export const SIGNAL_DELETE_DESC =
	"Artemis stops watching it. The alarm itself is not changed.";
